import React from "react";
import slider4 from "../assets/hol4.jpg";
import { LuMoveLeft } from "react-icons/lu";
import { Link } from "react-router-dom";
import SectionHeadline from "./SectionHeadline";

export default function Pharmacy() {
  return (
    <div className="md:px-0 px-4 flex justify-center items-center">
      <div className="md:shadow-md md:px-10 md:pb-4 flex flex-col md:gap-8 gap-4 justify-center md:w-10/12 w-full">
        <div
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="flex flex-col"
        >
          <SectionHeadline
            title=" Diploma in Pharmacy (D. Pharm)"
            backgroundImage={slider4}
          />
        </div>

        <div
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="flex flex-col gap-7"
        >
          <div className="md:-mt-3">
            The Diploma in Pharmacy (D. Pharm) program at Holy Vision Technical
            Campus (HVTC) provides students with a solid foundation in
            pharmaceutical sciences, focusing on practical training and
            theoretical knowledge essential for pharmacy practice. With
            state-of-the-art labs and experienced faculty, students gain
            hands-on experience in pharmaceutical compounding, drug delivery
            systems, and patient counseling.
          </div>
          <p>
            {" "}
            <strong> Duration: </strong> 3 years
          </p>
          <p>
            <strong> Affiliation: </strong> Council for Technical Education and
            Vocational Training (CTEVT)
          </p>
          <div className="flex flex-col gap-4">
            <strong> Eligibility: </strong>
            <div className=" flex flex-col gap-4">
              <li>Completion of SEE or equivalent with a minimum GPA of 2.0</li>
              <li>TSLC (CMA) With minimum 68.33%</li>
            </div>
          </div>
          <strong> Course Structure: </strong>
          {courseStructure.map((year, index) => (
            <div key={index} className="flex flex-col gap-4">
              <strong>{year.title}:</strong>
              <div className=" flex flex-col gap-4">
                {year.courses.map((course, idx) => (
                  <li key={idx}>{course}</li>
                ))}
              </div>
            </div>
          ))}
          <div className="flex flex-col gap-4">
            <strong> Career Prospects: </strong>
            <div className=" flex flex-col gap-4">
              {careerProspects.map((prospect, idx) => (
                <li key={idx}>{prospect}</li>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <strong> Key Features: </strong>
            <div className=" flex flex-col gap-4">
              {keyFeatures.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </div>
          </div>
          <div>
            <strong>Fee Structure</strong>
            <p className=" mt-2">3 Lakh 37 Thousnad 8 Hundred  Only (NPR.337800/-)</p>
          </div>
          <div className="flex flex-col gap-4">
            <strong> Facilities: </strong>
            <div className=" flex flex-col gap-4">
              {facilities.map((facility, idx) => (
                <li key={idx}>{facility}</li>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <strong>
              Why Holy Vision Technical Campus for Diploma in Pharmacy (D.
              Pharm)?
            </strong>
            <div className=" flex flex-col gap-4">
              {whyChooseHVTC.map((reason, idx) => (
                <li key={idx}>{reason}</li>
              ))}
            </div>
          </div>
          <strong>
            For more information or to apply, please visit the Holy Vision
            Technical Campus (HVTC) website or contact the admissions office.
          </strong>
          <Link
            to="/"
            className="cursor-pointer mt-4 hover:text-gray-700 flex gap-1 items-center justify-center"
          >
            <LuMoveLeft size={25} className="text-gray-800" />
            <p className="text-[18px]">Back</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

const courseStructure = [
  {
    title: "First Year",
    courses: [
      "English",
      "Nepali",
      "Social Studies (Nepali Parichaya)",
      "Mathematics , Statistics & Computer Application",
      "Physics ",
      "Chemistry ",
      "Zoology",
      "Botany",
      "Anatomy & Physiology",
    ],
  },
  {
    title: "Second Year",
    courses: [
      "Pharmaceutics- I",
      "Pharmacology I",
      "Pharmaceutical Chemistry I",
      "Pharmacotherapeutics I",
      "Biochemistry & Microbiology",
      "Pharmacotherapeutics I",
      "Pharmaceutical Management",
      "Public Health Pharmacy",
    ],
  },

  {
    title: "Third Year",
    courses: [
      "Pharmaceutics- II",
      "Pharmacology II",
      "Pharmaceutical Chemistry II",
      "Hospital and Clinical Pharmacy",
      "Pharmaceutical Jurisprudence and community Pharmacy",
      "Pharmacotherapeutics II",
      "Comprehensive Field Practice",
    ],
  },
];

const careerProspects = [
  "Assistent Pharmacist",
  "Assistent Hospital Pharmacist",
  "Assistent Clinical Pharmacist",
  "Medical Sales Representative",

];

const keyFeatures = [
  "Hands-on training in pharmaceutical labs and dispensaries.",
  "Focus on patient-oriented pharmacy practice.",
  "Introduction to pharmaceutical regulatory practices.",
  "Practical experience in drug formulation and compounding.",
];

const facilities = [
  "Well-equipped pharmaceutical laboratories.",
  "Access to pharmacy reference books and journals.",
  "Experienced faculty with industry experience.",
  "Internship opportunities in leading pharmacies.",
];

const whyChooseHVTC = [
  "Experienced Faculty in Pharmacy Education",
  "State-of-the-art Pharmaceutical Laboratories",
  "Comprehensive Pharmacy Curriculum",
  "Industry Tie-ups for Internships and Placements",
  "Practical Exposure to Pharmacy Practices",
  "Supportive Learning Environment for Pharmacy Students",
];
